import {CUSTOMER_PROFILE_USE_MOCK_API} from "~/components/entityProfile/customerProfileDataSource/config";
import {liveCustomerProfileDataSource} from "~/components/entityProfile/customerProfileDataSource/live/liveCustomerProfileDataSource";
import {mockCustomerProfileDataSource} from "~/components/entityProfile/customerProfileDataSource/mock/mockCustomerProfileApi";
import type {CustomerProfileDataSource} from "~/components/entityProfile/customerProfileDataSource/types";

export function getCustomerProfileDataSource(): CustomerProfileDataSource {
    if (CUSTOMER_PROFILE_USE_MOCK_API === true) {
        return mockCustomerProfileDataSource;
    }

    return liveCustomerProfileDataSource;
}

export {
    CUSTOMER_PROFILE_MOCK_API_DELAY_MS,
    CUSTOMER_PROFILE_USE_MOCK_API,
} from "~/components/entityProfile/customerProfileDataSource/config";
export type {
    CustomerProfileActivityContext,
    CustomerProfileDataSource,
    CustomerProfileEventsContext,
    CustomerProfileJourneysContext,
    CustomerProfileLifecycleBase,
    CustomerProfileLifecycleOption,
    CustomerProfileNotesContext,
    CustomerProfileTabApiData,
} from "~/components/entityProfile/customerProfileDataSource/types";
